import { App } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  forwardClient,
  setDraftBailiffOpenForward,
} from "store/bailiff/draft/bailiff/draft_bailiff.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDraftBailiffForward = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const params = useParams();
  const { bailiffId } = params;
  const navigate = useNavigate();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  // open
  const handleOpen = () => {
    dispatch(setDraftBailiffOpenForward(true));
  };

  const handleCancel = () => {
    dispatch(setDraftBailiffOpenForward(false));
  };

  const handleForward = () => {
    if (!bailiffId)
      return message.error("Lỗi không xác định, vui lòng reload lại trang");
    setLoading(true);
    dispatch(
      forwardClient({ id: bailiffId }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Gửi kết quả đến khách hàng thành công!");

          navigate("/bailiff", { replace: true });
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleForward, handleOpen, handleCancel };
};
